import React, { useState, useEffect, useRef, useContext } from "react";
import default_user_img from "../../assets/images/default_user.jpg";
import { IoIosNotificationsOutline } from "react-icons/io";
import { IoEyeOutline } from "react-icons/io5";
import { IoMdLogOut } from "react-icons/io";
import { Link, useLocation } from "react-router-dom";
import { AuthContext } from "../../utils/context/auth";
import NotificationModal from "./NotificationModal";
import axiosAuth from "../../utils/axios";
import { PiSignIn } from "react-icons/pi";
import { MdAppRegistration } from "react-icons/md";
import { IoHomeOutline, IoHelpCircleOutline} from "react-icons/io5";
import { TbUsersGroup } from "react-icons/tb";
import { AiOutlineProduct } from "react-icons/ai";
import { MdOutlineContactPhone } from "react-icons/md";
import { MdDarkMode, MdLightMode } from "react-icons/md";
import { IoShieldCheckmark } from "react-icons/io5";
import SalesRepAccessModal from "./SalesRepAccessModal";
import toast from "react-hot-toast";
import logo from "../../assets/images/logo.png";
const navStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,500;1,400&family=Syne:wght@300;400;500;600&display=swap');
  .pmnav-root { font-family: 'Syne', sans-serif; }
  .pmnav-logo-mark { width:30px;height:30px;background:#0A0F1E;border-radius:6px;display:flex;align-items:center;justify-content:center;flex-shrink:0; }
  .pmnav-logo-mark span { color:#fff;font-size:11px;font-weight:600;letter-spacing:-0.5px; }
  .pmnav-logo-text { font-size:15px;font-weight:500;letter-spacing:0.4px;color:#0A0F1E; }
  .dark .pmnav-logo-text { color:#f1f5f9; }
  .pmnav-logo-text em { color:#00897B;font-style:normal; }
  .pmnav-link { font-size:12px;font-weight:400;color:#6C7589;text-decoration:none;letter-spacing:0.5px;cursor:pointer;transition:color 0.2s;padding:4px 0;position:relative; }
  .dark .pmnav-link { color:#94a3b8; }
  .pmnav-link:hover, .pmnav-link.active { color:#0A0F1E; }
  .dark .pmnav-link:hover, .dark .pmnav-link.active { color:#f1f5f9; }
  .pmnav-link.active::after { content:''; position:absolute; bottom:-2px; left:0; right:0; height:1.5px; background:#00897B; border-radius:2px; }
  .pmnav-portal { font-size:11px;color:#6C7589;cursor:pointer;letter-spacing:0.5px;border:1px solid rgba(10,15,30,0.15);padding:7px 16px;border-radius:4px;background:transparent;transition:all 0.2s; }
  .dark .pmnav-portal { color:#94a3b8; border-color:rgba(255,255,255,0.15); }
  .pmnav-portal:hover { border-color:#00897B; color:#00897B; }
  .pmnav-cta { font-size:11px;font-weight:500;background:#0A0F1E;color:white;padding:8px 18px;border-radius:4px;cursor:pointer;letter-spacing:0.5px;border:none;transition:background 0.2s; }
  .dark .pmnav-cta { background:#1e293b; }
  .pmnav-cta:hover { background:#00897B; }
  .pmnav-reg { font-size:11px;font-weight:500;background:transparent;color:#0A0F1E;padding:7px 18px;border-radius:4px;cursor:pointer;letter-spacing:0.5px;border:1px solid rgba(10,15,30,0.25);transition:all 0.2s; }
  .dark .pmnav-reg { color:#f1f5f9; border-color:rgba(255,255,255,0.2); }
  .pmnav-reg:hover { border-color:#00897B; color:#00897B; }
  .pmnav-divider { height:1px; background:rgba(10,15,30,0.08); }
  .dark .pmnav-divider { background:rgba(255,255,255,0.07); }
`;

const MobileMenuIconSVG = () => (
  <svg className="block h-5 w-5 fill-current text-gray-600 dark:text-gray-300 transition-transform duration-300 hover:scale-110" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"></path>
  </svg>
);

const CloseMenuIconSVG = () => (
  <svg className="h-5 w-5 text-gray-500 dark:text-gray-400 cursor-pointer hover:text-gray-800 dark:hover:text-gray-200 transition-all duration-300" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
  </svg>
);

const Navbar = ({ isDarkMode, setIsDarkMode }) => {
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);
  const [notifications, setNotifications] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedNotification, setSelectedNotification] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const notificationRef = useRef(null);
  const [showSalesRepModal, setShowSalesRepModal] = useState(false);
  const [salesRepData, setSalesRepData] = useState(null);
  const [isSalesRepLoading, setIsSalesRepLoading] = useState(false);
  const mobileMenuRef = useRef(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 1024);
  const { user, logout, loading: authLoading } = useContext(AuthContext);

  const isActive = (path) => {
    if (path === "/") return location.pathname === "/";
    if (path === "/dashboard/") return location.pathname.startsWith("/dashboard");
    return location.pathname.startsWith(path);
  };

  const isAuthenticated = !!user && !authLoading;
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const profileRef = useRef(null);
  const scrollPositionRef = useRef(0);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen((prev) => {
      const newState = !prev;
      if (newState && mobileMenuRef.current) {
        mobileMenuRef.current.scrollTop = 0;
        setTimeout(() => { if (mobileMenuRef.current) mobileMenuRef.current.scrollTop = 0; }, 100);
      }
      return newState;
    });
  };

  const closeMobileMenu = () => setIsMobileMenuOpen(false);

  const toggleDarkMode = () => {
    const newMode = !isDarkMode;
    setIsDarkMode(newMode);
    localStorage.setItem("darkMode", newMode);
    if (newMode) document.documentElement.classList.add("dark");
    else document.documentElement.classList.remove("dark");
  };

  useEffect(() => {
    const fetchStatus = async () => {
      if (!isAuthenticated) return;
      try {
        const axiosInstance = axiosAuth();
        const response = await axiosInstance.get('/provider/sales-rep-access-status/');
        if (response.data.success) setSalesRepData(response.data);
      } catch (error) { console.error("Failed to fetch sales rep status:", error); }
    };
    if (isAuthenticated) fetchStatus();
  }, [isAuthenticated]);

  const handleToggleAccess = async () => {
    setIsSalesRepLoading(true);
    try {
      const axiosInstance = axiosAuth();
      const response = await axiosInstance.post('/provider/toggle-sales-rep-access/');
      if (response.data.success) {
        setSalesRepData(prev => ({ ...prev, access_granted: response.data.access_granted }));
        toast.success(response.data.message);
      }
    } catch (error) {
      toast.error(error.response?.data?.error || 'Failed to update access');
    } finally { setIsSalesRepLoading(false); }
  };

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (isMobileMenuOpen) {
      scrollPositionRef.current = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
      document.body.classList.add('menu-open');
      document.documentElement.classList.add('menu-open');
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollPositionRef.current}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.height = '100%';
      document.documentElement.style.overflow = 'hidden';
      document.documentElement.style.position = 'fixed';
      document.documentElement.style.height = '100%';
      document.body.style.touchAction = 'none';
      const preventScroll = (e) => { e.preventDefault(); e.stopPropagation(); return false; };
      window.addEventListener('scroll', preventScroll, { passive: false, capture: true });
      window.addEventListener('wheel', preventScroll, { passive: false, capture: true });
      window.addEventListener('touchmove', preventScroll, { passive: false, capture: true });
      return () => {
        window.removeEventListener('scroll', preventScroll, { capture: true });
        window.removeEventListener('wheel', preventScroll, { capture: true });
        window.removeEventListener('touchmove', preventScroll, { capture: true });
        document.body.classList.remove('menu-open');
        document.documentElement.classList.remove('menu-open');
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.width = '';
        document.body.style.height = '';
        document.body.style.touchAction = '';
        document.documentElement.style.overflow = '';
        document.documentElement.style.position = '';
        document.documentElement.style.height = '';
        window.scrollTo(0, scrollPositionRef.current);
      };
    } else {
      document.body.classList.remove('menu-open');
      document.documentElement.classList.remove('menu-open');
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      document.body.style.height = '';
      document.documentElement.style.overflow = '';
      document.documentElement.style.position = '';
      document.documentElement.style.height = '';
    }
  }, [isMobileMenuOpen]);

  useEffect(() => {
    if (isMobileMenuOpen && mobileMenuRef.current) {
      const timer = setTimeout(() => { if (mobileMenuRef.current) mobileMenuRef.current.scrollTop = 0; }, 50);
      return () => clearTimeout(timer);
    }
  }, [isMobileMenuOpen]);

  useEffect(() => {
    const checkMobileView = () => {
      const isMobile = window.innerWidth < 1024;
      setIsMobileView(isMobile);
      if (!isMobile && isMobileMenuOpen) closeMobileMenu();
    };
    checkMobileView();
    window.addEventListener("resize", checkMobileView, { passive: true });
    window.addEventListener("orientationchange", checkMobileView, { passive: true });
    const mediaQuery = window.matchMedia("(max-width: 1023px)");
    const handleMediaChange = (e) => { setIsMobileView(e.matches); if (!e.matches && isMobileMenuOpen) closeMobileMenu(); };
    if (mediaQuery.addEventListener) mediaQuery.addEventListener("change", handleMediaChange);
    else mediaQuery.addListener(handleMediaChange);
    return () => {
      window.removeEventListener("resize", checkMobileView);
      window.removeEventListener("orientationchange", checkMobileView);
      if (mediaQuery.removeEventListener) mediaQuery.removeEventListener("change", handleMediaChange);
      else mediaQuery.removeListener(handleMediaChange);
    };
  }, [isMobileMenuOpen]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (notificationRef.current && !notificationRef.current.contains(event.target)) setShowDropdown(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileRef.current && !profileRef.current.contains(event.target)) setShowProfileDropdown(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const fetchNotifications = async () => {
      if (!user) return;
      try {
        const axiosInstance = axiosAuth();
        const [notifRes, countRes] = await Promise.all([
          axiosInstance.get("/notifications/"),
          axiosInstance.get("/notifications/unread-count/"),
        ]);
        setNotifications(notifRes.data);
        setNotificationCount(countRes.data.unread_count || 0);
      } catch (error) { console.error("Failed to fetch notifications:", error); }
    };
    if (isAuthenticated) fetchNotifications();
  }, [isAuthenticated, user]);

  function removeDuplicateMedia(url) {
    if (url && typeof url === "string") {
      const duplicatedSegment = "media/images/";
      if (url.includes(duplicatedSegment)) return url.replace(duplicatedSegment, "images/");
    }
    return url;
  }

  const handleNotificationClick = (notification) => {
    setSelectedNotification(notification);
    setShowModal(true);
    markAsRead(notification.id);
    setShowDropdown(false);
    closeMobileMenu();
  };

  const markAsRead = async (id) => {
    try {
      const axiosInstance = axiosAuth();
      await axiosInstance.patch(`/${id}/mark-read/`);
      setNotificationCount((prev) => Math.max(prev - 1, 0));
      setNotifications((prev) => prev.map((n) => (n.id === id ? { ...n, is_read: true } : n)));
    } catch (error) { console.error("Failed to mark notification as read:", error); }
  };

  const deleteNotification = async (id) => {
    try {
      const axiosInstance = axiosAuth();
      await axiosInstance.delete(`/${id}/delete-notification/`);
      setNotifications((prev) => prev.filter((n) => n.id !== id));
      setShowModal(false);
    } catch (error) { console.error("Failed to delete notification:", error); }
  };

  function getTimeLabel(dateCreated) {
    const now = new Date();
    const created = new Date(dateCreated);
    const diffTime = Math.abs(now - created);
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    if (diffDays === 0) return "Today";
    if (diffDays === 1) return "1 day ago";
    if (diffDays < 7) return `${diffDays} days ago`;
    if (diffDays < 14) return "1 week ago";
    if (diffDays < 21) return "2 weeks ago";
    if (diffDays < 30) return "3 weeks ago";
    return "More than 30 days ago";
  }

  const profile = user;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: navStyles }} />
      <div
        className={`pmnav-root fixed top-0 left-0 right-0 z-[100] transition-all duration-300 ${
          scrolled
            ? "bg-white/95 dark:bg-gray-950/95 backdrop-blur-md shadow-sm"
            : "bg-white dark:bg-gray-950"
        }`}
      >
        {/* Top border accent */}
        <div style={{ height: '2px', background: 'linear-gradient(90deg, #00897B, #0A0F1E)' }}></div>

        <nav className="px-6 lg:px-8 h-[62px] flex items-center justify-between w-full">

          {/* Logo */}
          <Link to="/" className="flex items-center gap-2.5 flex-shrink-0" style={{ textDecoration: 'none' }}>
            <img src={logo} alt="ProMed Health Plus" style={{ height: '36px', width: 'auto' }} />
            <span className="pmnav-logo-text">ProMed <em>Health+</em></span>
          </Link>

          {/* Desktop Nav Links */}
          <div className="hidden lg:flex items-center gap-7">
            {isAuthenticated ? (
              <Link to="/dashboard/" className={`pmnav-link ${isActive('/dashboard/') ? 'active' : ''}`}>Dashboard</Link>
            ) : (
              <>
                <Link to="/about/" className={`pmnav-link ${isActive('/about/') ? 'active' : ''}`}>About</Link>
                <Link to="/how-it-works" className={`pmnav-link ${isActive('/how-it-works') ? 'active' : ''}`}>How It Works</Link>

                <Link to="/products/" className={`pmnav-link ${isActive('/products/') ? 'active' : ''}`}>Products</Link>
                <Link to="/contact/" className={`pmnav-link ${isActive('/contact/') ? 'active' : ''}`}>Contact</Link>
              </>
            )}
          </div>

          {/* Right Side */}
          <div className="flex items-center gap-3">

            {/* Mobile burger */}
            <div className="lg:hidden" style={{ position: 'relative', zIndex: 101 }}>
              <button
                type="button"
                className="p-2 rounded-md hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors duration-200"
                onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggleMobileMenu(); }}
                style={{ position: 'relative', zIndex: 101, cursor: 'pointer', touchAction: 'manipulation' }}
              >
                <MobileMenuIconSVG />
              </button>
            </div>

            {/* Dark mode toggle — hidden on home page */}
            {location.pathname !== "/" && (
              <button
                onClick={toggleDarkMode}
                className="hidden lg:flex p-2 rounded-md hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors duration-200"
                aria-label="Toggle Dark Mode"
              >
                {isDarkMode
                  ? <MdLightMode size={18} className="text-yellow-500" />
                  : <MdDarkMode size={18} className="text-gray-500 dark:text-gray-400" />
                }
              </button>
            )}

            {/* Sales Rep Button - Desktop */}
            {isAuthenticated && !authLoading && user?.role === 'provider' && (
              <button
                onClick={() => { if (salesRepData?.has_sales_rep) setShowSalesRepModal(true); else toast.error("No sales rep assigned yet"); }}
                disabled={!salesRepData?.has_sales_rep}
                className={`hidden lg:flex items-center gap-2 px-3 py-2 rounded-md text-xs font-medium transition-all duration-200 flex-shrink-0 ${
                  salesRepData?.has_sales_rep
                    ? salesRepData?.access_granted
                      ? 'bg-green-500 hover:bg-green-600 text-white cursor-pointer'
                      : 'bg-teal-600 hover:bg-teal-700 text-white cursor-pointer'
                    : 'bg-gray-100 dark:bg-gray-800 text-gray-400 cursor-not-allowed opacity-50'
                }`}
              >
                <IoShieldCheckmark size={14} />
                <span>{salesRepData?.has_sales_rep ? (salesRepData?.access_granted ? "Rep: ON" : "Give Access") : "No Rep"}</span>
              </button>
            )}

            {authLoading ? (
              <div className="hidden lg:flex items-center gap-3">
                <div className="h-8 w-8 bg-gray-100 dark:bg-gray-800 rounded-full animate-pulse"></div>
              </div>
            ) : isAuthenticated ? (
              <div className="hidden lg:flex items-center gap-3">

                {/* Notifications */}
                <div className="relative" ref={notificationRef}>
                  <button
                    className="relative p-2 rounded-md hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors duration-200"
                    onClick={() => setShowDropdown((prev) => !prev)}
                  >
                    <IoIosNotificationsOutline className="text-xl text-gray-500 dark:text-gray-400" />
                    {notificationCount > 0 && (
                      <span className="absolute -top-0.5 -right-0.5 bg-red-500 text-white text-[9px] font-bold rounded-full h-4 w-4 flex items-center justify-center">
                        {notificationCount}
                      </span>
                    )}
                  </button>
                  {showDropdown && (
                    <div className="absolute right-0 mt-2 w-80 bg-white dark:bg-gray-900 rounded-xl shadow-xl border border-gray-100 dark:border-gray-700 z-50 overflow-hidden">
                      <div className="px-4 py-3 border-b border-gray-100 dark:border-gray-700">
                        <h3 className="text-xs font-semibold text-gray-800 dark:text-gray-200 uppercase tracking-wider">Notifications</h3>
                      </div>
                      <ul className="max-h-80 overflow-y-auto">
                        {notifications.length > 0 ? notifications.map((notif) => (
                          <li key={notif.id} onClick={() => handleNotificationClick(notif)}
                            className={`px-4 py-3 flex flex-col border-b border-gray-50 dark:border-gray-800 last:border-b-0 cursor-pointer transition-colors duration-150 ${
                              notif.is_read ? "bg-gray-50 dark:bg-gray-800/50 text-gray-400" : "hover:bg-gray-50 dark:hover:bg-gray-800 text-gray-700 dark:text-gray-300"
                            }`}>
                            <div className="flex justify-between items-start gap-2">
                              <span className="text-xs flex-1">{notif.message}</span>
                              {notif.data && <IoEyeOutline className="text-teal-500 text-sm flex-shrink-0" />}
                            </div>
                            <span className="text-[10px] text-gray-400 mt-1">{getTimeLabel(notif.date_created)}</span>
                          </li>
                        )) : (
                          <li className="px-4 py-8 text-xs text-gray-400 text-center">No notifications yet</li>
                        )}
                      </ul>
                    </div>
                  )}
                </div>

                {/* Profile */}
                <div className="relative" ref={profileRef} onClick={() => setShowProfileDropdown(true)}>
                  <div className="flex items-center gap-2.5 cursor-pointer group">
                    <span className="text-xs font-medium text-gray-600 dark:text-gray-300 hidden xl:block">
                      {profile?.full_name || profile?.email || "User"}
                    </span>
                    <div className="relative">
                      <img
                        src={
                          profile?.image?.startsWith("http")
                            ? removeDuplicateMedia(profile.image)
                            : profile?.image
                            ? `${process.env.REACT_APP_MEDIA_URL}${profile.image}`
                            : default_user_img
                        }
                        alt="Profile"
                        className="w-8 h-8 rounded-full object-cover object-top border border-gray-200 dark:border-gray-700"
                      />
                      <span className="absolute bottom-0 right-0 w-2 h-2 bg-green-500 rounded-full border border-white dark:border-gray-950"></span>
                    </div>
                  </div>
                  {showProfileDropdown && (
                    <div className="absolute right-0 mt-2 w-52 bg-white dark:bg-gray-900 rounded-xl shadow-xl border border-gray-100 dark:border-gray-700 z-50 overflow-hidden">
                      <div className="px-4 py-3 border-b border-gray-100 dark:border-gray-700">
                        <p className="text-xs font-semibold text-gray-800 dark:text-gray-200 truncate">{profile?.full_name || profile?.email || "User"}</p>
                      </div>
                      <Link to="/profile" className="flex items-center px-4 py-2.5 text-xs text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors duration-150" onClick={() => setShowProfileDropdown(false)}>
                        <IoEyeOutline className="mr-2.5 text-sm" /> View Profile
                      </Link>
                      <button onClick={() => { logout(); setShowProfileDropdown(false); }}
                        className="w-full text-left flex items-center px-4 py-2.5 text-xs text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors duration-150">
                        <IoMdLogOut className="mr-2.5 text-sm" /> Logout
                      </button>
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <div className="hidden lg:flex items-center gap-2.5">
                <Link to="/login">
                  <button className="pmnav-portal flex items-center gap-1.5">
                    <PiSignIn size={13} /> Member Login
                  </button>
                </Link>
                <Link to="/login">
                  <button className="pmnav-portal flex items-center gap-1.5">
                    <PiSignIn size={13} /> Employer Login
                  </button>
                </Link>
                <Link to="/register">
                  {/* <span className="pmnav-tooltip">Registration for Providers and Customers</span> */}
                  <button className="pmnav-cta flex items-center gap-1.5">
                    <MdAppRegistration size={13} /> Register
                  </button>
                
              </Link>
              </div>
            )}
          </div>
        </nav>

        {/* Bottom border */}
        <div className="pmnav-divider"></div>

        {/* Mobile Menu */}
        <div className={`navbar-menu fixed inset-0 z-[60] ${isMobileMenuOpen ? "" : "pointer-events-none"}`}>
          <div
            className={`fixed inset-0 bg-black/40 backdrop-blur-sm transition-opacity duration-300 ${isMobileMenuOpen ? "opacity-100" : "opacity-0"}`}
            onClick={(e) => { if (e.target === e.currentTarget) closeMobileMenu(); }}
            style={{ touchAction: 'none' }}
          ></div>

          <nav
            ref={mobileMenuRef}
            className={`fixed top-0 left-0 h-screen flex flex-col w-5/6 max-w-sm py-6 px-6 bg-white dark:bg-gray-950 transform transition-all duration-400 ease-out z-[60] shadow-2xl ${
              isMobileMenuOpen ? "translate-x-0" : "-translate-x-full"
            }`}
            style={{ overflowY: 'auto', maxHeight: '100vh', overscrollBehavior: 'none', scrollbarWidth: 'none' }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Mobile Header */}
            <div className="flex items-center justify-between mb-8">
              <Link to="/" className="flex items-center gap-2.5" style={{ textDecoration: 'none' }}>
                <img src={logo} alt="ProMed Health Plus" style={{ height: '32px', width: 'auto' }} />
                <span className="pmnav-logo-text">ProMed <em>Health+</em></span>
              </Link>
              <button onClick={closeMobileMenu} className="p-1"><CloseMenuIconSVG /></button>
            </div>

            {/* Mobile Links */}
            <ul className="space-y-1">
              {[
                { to: "/", label: "Home", icon: <IoHomeOutline size={14} className="mr-2" /> },
                ...(isAuthenticated ? [
                  { to: "/dashboard/", label: "Dashboard" },
                  { to: "/profile", label: "Profile" },
                ] : [
                  { to: "/about/", label: "About Us", icon: <TbUsersGroup size={14} className="mr-2" /> },
                  { to: "/how-it-works", label: "How It Works", icon: <IoHelpCircleOutline size={14} className="mr-2" /> },
                  { to: "/products/", label: "Products", icon: <AiOutlineProduct size={14} className="mr-2" /> },
                  { to: "/contact/", label: "Contact", icon: <MdOutlineContactPhone size={14} className="mr-2" /> },
                ])
              ].map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    onClick={closeMobileMenu}
                    className={`flex items-center px-3 py-2.5 text-sm rounded-lg transition-colors duration-150 ${
                      isActive(item.to)
                        ? "bg-teal-50 dark:bg-teal-900/20 text-teal-700 dark:text-teal-400 font-medium"
                        : "text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800"
                    }`}
                  >
                    {item.icon}{item.label}
                  </Link>
                </li>
              ))}
            </ul>

            {/* Mobile authenticated profile */}
            {isAuthenticated && (
              <div className="flex items-center gap-3 mt-6 p-3 bg-gray-50 dark:bg-gray-900 rounded-xl border border-gray-100 dark:border-gray-800">
                <div className="relative">
                  <img
                    src={
                      profile?.image?.startsWith("http") ? removeDuplicateMedia(profile.image)
                        : profile?.image ? `${process.env.REACT_APP_MEDIA_URL}${profile.image}` : default_user_img
                    }
                    alt="Profile"
                    className="w-10 h-10 rounded-full object-cover object-top border border-gray-200 dark:border-gray-700"
                  />
                  <span className="absolute bottom-0 right-0 w-2.5 h-2.5 bg-green-500 rounded-full border-2 border-white dark:border-gray-950"></span>
                </div>
                <span className="text-sm font-medium text-gray-800 dark:text-gray-200 flex-1 truncate">
                  {profile?.full_name || profile?.email || "User"}
                </span>
              </div>
            )}

              {/* Mobile bottom buttons */}
            <div className="mt-auto pt-6 flex flex-col gap-2.5">
              {location.pathname !== "/" && (
                <button onClick={toggleDarkMode}
                  className="w-full px-4 py-2.5 text-xs font-medium text-gray-600 dark:text-gray-300 bg-gray-100 dark:bg-gray-800 rounded-lg transition-colors hover:bg-gray-200 dark:hover:bg-gray-700 flex items-center justify-center gap-2">
                  {isDarkMode ? <MdLightMode size={16} /> : <MdDarkMode size={16} />}
                  Toggle Dark Mode
                </button>
              )}

              {isAuthenticated ? (
                <>
                  {user?.role === 'provider' && salesRepData?.has_sales_rep && (
                    <button
                      onClick={() => { setShowSalesRepModal(true); setShowDropdown(false); }}
                      className={`w-full px-4 py-2.5 text-xs font-medium rounded-lg flex items-center justify-center gap-2 ${
                        salesRepData?.access_granted ? 'bg-green-500 hover:bg-green-600 text-white' : 'bg-teal-600 hover:bg-teal-700 text-white'
                      }`}
                    >
                      <IoShieldCheckmark size={14} />
                      {salesRepData?.access_granted ? "Rep Access: ON" : "Give Rep Access"}
                    </button>
                  )}
                  <button onClick={() => setShowDropdown((prev) => !prev)}
                    className="w-full px-4 py-2.5 text-xs font-medium text-gray-600 dark:text-gray-300 bg-gray-100 dark:bg-gray-800 rounded-lg flex items-center justify-center gap-2 relative">
                    <IoIosNotificationsOutline size={16} /> Notifications
                    {notificationCount > 0 && (
                      <span className="bg-red-500 text-white text-[9px] rounded-full h-4 w-4 flex items-center justify-center">{notificationCount}</span>
                    )}
                  </button>
                  {showDropdown && (
                    <div className="w-full bg-white dark:bg-gray-900 rounded-xl border border-gray-100 dark:border-gray-700 overflow-hidden">
                      <ul className="max-h-52 overflow-y-auto">
                        {notifications.length > 0 ? notifications.map((notif) => (
                          <li key={notif.id} onClick={() => handleNotificationClick(notif)}
                            className="px-4 py-2.5 border-b border-gray-50 dark:border-gray-800 last:border-b-0 cursor-pointer text-xs text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800">
                            {notif.message}
                          </li>
                        )) : (
                          <li className="px-4 py-6 text-xs text-gray-400 text-center">No notifications yet</li>
                        )}
                      </ul>
                    </div>
                  )}
                  <button onClick={() => { logout(); closeMobileMenu(); }}
                    className="w-full px-4 py-2.5 text-xs font-medium text-red-500 bg-red-50 dark:bg-red-900/10 rounded-lg">
                    Logout
                  </button>
                </>
              ) : (
                <>
                  <Link to="/login" onClick={closeMobileMenu}>
                    <button className="w-full px-4 py-2.5 text-xs font-medium text-gray-600 dark:text-gray-300 border border-gray-200 dark:border-gray-700 rounded-lg flex items-center justify-center gap-2 hover:border-teal-500 hover:text-teal-600 transition-colors">
                      <PiSignIn size={14} /> Member Login
                    </button>
                  </Link>
                   <Link to="/login" onClick={closeMobileMenu}>
                    <button className="w-full px-4 py-2.5 text-xs font-medium text-gray-600 dark:text-gray-300 border border-gray-200 dark:border-gray-700 rounded-lg flex items-center justify-center gap-2 hover:border-teal-500 hover:text-teal-600 transition-colors">
                      <PiSignIn size={14} /> Employer Login
                    </button>
                  </Link>
                  <Link to="/register" onClick={closeMobileMenu}>
                    <button className="w-full px-4 py-2.5 text-xs font-medium text-white bg-gray-900 dark:bg-gray-800 rounded-lg flex items-center justify-center gap-2 hover:bg-teal-700 transition-colors">
                      <MdAppRegistration size={14} /> Register
                    </button>
                  </Link>
                </>
              )}
            </div>

            <p className="mt-6 text-[10px] text-center text-gray-300 dark:text-gray-600">
              ProMed Health Plus © {new Date().getFullYear()}
            </p>
          </nav>
        </div>

        {isAuthenticated && (
          <SalesRepAccessModal isOpen={showSalesRepModal} onClose={() => setShowSalesRepModal(false)}
            salesRepData={salesRepData} onToggle={handleToggleAccess} isLoading={isSalesRepLoading} />
        )}

        <NotificationModal open={showModal} handleClose={() => setShowModal(false)}
          notification={selectedNotification} handleDelete={deleteNotification} />
      </div>
    </>
  );
};

export default Navbar;